import React from 'react'
import { TriadGraphicHistory } from './TriadGraphicHistory';
import { DateTemplate } from '../../../components/dateTemplate/DateTemplate';

export const TriadFirstTabV1: React.FC<{ triad: any, created: boolean, hirearchy: any, inputMonth: number, inputYear: number, viewAnswers: (currTriad: any) => void }> = ({ triad, created, hirearchy, inputMonth, inputYear, viewAnswers }) => {
    return (
        <><p className="margin-top-20" style={{ fontSize: '17px' }}>
            The purpose of this assessment is to provide feedback on the supervisor’s coaching
            effectiveness based on the following categories: Welcome, Preparedness, Collaboration,
            Commitment, Inspection and Closing.
        </p>
            {created && (
                <>
                    <h5 className="margin-top-20">Creation Date : {DateTemplate(triad?.create_date)}</h5>
                    <h5 className="flex-display margin-top-20">
                        Team Lead Acknowledged :{' '}
                        <p className="margin-0">
                            {triad?.acknowledged ? DateTemplate(triad?.acknowledge_date) : ' n/a'}
                        </p>{' '}
                    </h5>
                </>
            )}

            <div className="row triad-first-tab-cotainer margin-top-20">
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-12" style={{ textAlign: 'start', fontSize: 'larger' }}>
                            What do the points mean?
                        </div>
                        <hr />
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            {[
                                { score: "3", label: "Strongly Demonstrates", desc: "Demonstrates a mastery of the task" },
                                { score: "2", label: "Satisfactorily Demonstrates", desc: "Demonstrates a good understanding of the task" },
                                { score: "1", label: "Does Not Demonstrate", desc: "Skills should be improved" },
                                { score: "N/A", label: "Does Not Apply", desc: "Does Not Apply" },
                            ].map(({ score, label, desc }) => (
                                <div className="row" key={score}>
                                    <div style={{ textAlign: 'start' }} className="col-md-4">
                                        {label}
                                    </div>
                                    <div style={{ textAlign: 'start' }} className="col-md-8">
                                        {score === "N/A" ? '' : `(${score}): `} {desc}
                                    </div>
                                    <div className="col-md-12">
                                        <hr />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="col-md-5">
                    <TriadGraphicHistory
                        viewAnswers={viewAnswers}
                        year={inputYear}
                        month={inputMonth}
                        empNo={hirearchy?.teamLeadId}
                    />
                </div>
            </div>
            <p className="margin-top-20" style={{ fontSize: '17px' }}>
                <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://ttectalent.sumtotal.host/core/libraryShare?TopicId=2386&TopicName=Engage%20Enablement%20-%20Team%20Lead%20Development&SearchText="
                >
                    Team Lead Enablement Library
                </a>
            </p></>
    )
}
